import supportNavigationConfig from './support.navigation.config.jsx'
import generalNavigationConfig from './general.navigation.config.jsx'
import manageNavigationConfig from './manage.navigation.config.jsx'
import administrativeNavigationConfig from './administrative.navigation.config.jsx'
import culturalNavigationConfig from './cultural.navigation.config.jsx'
import financialNavigationConfig from './financial.navigation.config.jsx'
import type {NavigationTree} from '@/@types/navigation'
// import docNavigationConfig from '@/configs/navigation.config/doc.navigation.config'
// import pagesNavigationConfig from '@/configs/navigation.config/pages.navigation.config'
// import uiComponentNavigationConfig from '@/configs/navigation.config/ui-components.navigation.config'
// import authNavigationConfig from '@/configs/navigation.config/auth.navigation.config'
//
const navigationConfig: NavigationTree[] = [
    ...generalNavigationConfig,
    ...administrativeNavigationConfig,
    ...culturalNavigationConfig,
    ...financialNavigationConfig,
    ...supportNavigationConfig,
    ...manageNavigationConfig,
    // ...uiComponentNavigationConfig,
    // ...pagesNavigationConfig,
    // ...authNavigationConfig,
    // ...docNavigationConfig,
]

export default navigationConfig
